/* eslint-disable no-unused-expressions */
/* eslint-disable no-unused-vars */
import { SvgIcon } from "@material-ui/core";
import { Box, Button, Modal, Typography } from "@mui/material";
import React, { useCallback, useEffect, useState } from "react";
import { FiUpload } from "react-icons/fi";
import Swal from "sweetalert2";
import { globalColors } from "../../../../../../../../../_metronic/_assets/sass/custom/globalColors";
import { ReactComponent as downloadIcon } from "../../../../../../../../assets/custom-icons/download.svg";
import { ReactComponent as trashIcon } from "../../../../../../../../assets/custom-icons/trash.svg";
import { ReactComponent as IconCircleLeft } from "../../../../../../../../assets/icons/akar-icons_circle_dark.svg";
import { ReactComponent as iconPlus } from "../../../../../../../../assets/icons/icon-plus-green.svg";
import { ReactComponent as IconCircleRight } from "../../../../../../../../assets/icons/icon_circle-chevron-right-fill.svg";
import { AppAPIService } from "../../../../../../../../services/AppAPIService";
import { arrayToFileList } from "../../../../../../../../utils/arrayToFileList";
import Loading from "../../../../../../../home/components/Loading";
import styles from "./styles.module.scss";
import JSZip from "jszip";

export const UploadModal = (props) => {
  const api = AppAPIService.getInstance();
  const data = props.dados;
  const documentId = data?.documentId;
  const filesList = props.filesList;

  const [files, setFiles] = useState([{ file: "" }]);
  const [seeDownloadAllButton, setSeeDownloadAllButton] = useState(false);

  const replaceFilesAtIndex = (newFiles, index) => {
    setFiles((previousFiles) => {
      const updatedFiles = [...previousFiles];
      updatedFiles.splice(index, 1, ...newFiles.map((file) => ({ file })));
      return updatedFiles;
    });
  };

  const handleChangeFiles = (event, index) => {
    replaceFilesAtIndex(Array.from(event.target.files), index);
  };

  const handleDropFiles = (event, index) => {
    event.preventDefault();
    const droppedFiles = Array.from(event.dataTransfer.files || []);
    if (droppedFiles.length > 0) {
      replaceFilesAtIndex(droppedFiles, index);
    }
  };

  useEffect(() => {
    if (filesList && filesList.length > 0) {
      setFiles(filesList.map((file) => ({ file })));
      if (filesList.length > 1) {
        setSeeDownloadAllButton(true);
      }
    }
  }, [filesList]);

  const [loading, setLoading] = useState();

  const handleCloseModal = useCallback(() => {
    setFiles([{ file: "" }]);
    props.handleOpen(false);
  }, [props]);

  const submitUpload = useCallback(
    async () => {
      const selectedFiles = files.filter(
        ({ file }) => file && file.name && !file.documentId
      );
      const fileList = [...arrayToFileList(selectedFiles)];
      if (fileList.length === 0) {
        await Swal.fire({
          icon: "warning",
          title: "Selecione um arquivo",
          text: "Inclua ao menos um documento antes de continuar.",
        });
        return;
      }

      setLoading(true);
      Swal.fire({
        title: "Carregando...",
        html: "Aguarde um momento",
        showConfirmButton: false,
      });

      try {
        let formData = new FormData();

        const typeDoc = "docUser";

        fileList.forEach((file, i) => {
          formData.append(`files[]`, file);
        });

        formData.append("documentId", documentId);
        formData.append("typeDoc", typeDoc);

        const response = await api.uploadRequest(
          formData,
          documentId,
          typeDoc
        );
        if (!response) {
          throw new Error("A API não confirmou o envio do documento.");
        }

        Swal.close();
        handleCloseModal();

        Swal.fire({
          icon: "success",
          title: "Sucesso!",
          text: `Documento enviado com sucesso.`,
        }).then(() => {
          props.refetchLogs?.();
          props.setReload?.((current) => !current);
          clearEditForm();
          props.handleGetDocuments?.();
          if (props?.handleGetParent) {
            props.handleGetParent();
          }
        });
      } catch (error) {
        Swal.close();
        Swal.fire({
          icon: "error",
          title: "Erro!",
          text: `Erro ao enviar documento, tente novamente ou contate o suporte.`,
        });
      } finally {
        setLoading(false);
      }
    },
    [props, files, documentId, handleCloseModal, api]
  );

  const clearEditForm = () => {
    setFiles([{ file: "" }]);
  };

  const handleAddRow = () => {
    setFiles((prevState) => [...prevState, { file: "" }]);
  };

  const handleDelteRow = (index) => {
    setFiles((prevState) =>
      prevState.length > 1
        ? prevState.filter((_, fileIndex) => fileIndex !== index)
        : prevState
    );
  };

  const handleDownloadRow = useCallback(
    async (filesKeys, documentId) => {
      if (!filesKeys || filesKeys.length === 0) {
        Swal.fire("Desculpe!", "Não contém arquivo!", "error");
      } else {
        Swal.fire({
          title: "Carregando...",
          html: "Aguarde um momento",
          showConfirmButton: false,
        });
        const link = await api.makeHttpRequest({
          method: "GET",
          url: "/document/download",
          params: {
            fileKey: filesKeys,
            documentId,
          },
        });

        window.open(link, "_blank");
        Swal.close();
      }
    },
    [api]
  );

  const handleDownloadAll = async () => {
    if (!files || files.length === 0) {
      Swal.fire("Desculpe!", "Não contém arquivo!", "error");
      return;
    }

    Swal.fire({
      title: "Carregando...",
      html: "Aguarde um momento",
      showConfirmButton: false,
      onBeforeOpen: () => {
        Swal.showLoading();
      },
    });

    const zip = new JSZip();
    const linkFiles = [];

    try {
      for await (const { file } of files) {
        if (file.fileKey) {
          const link = await api.makeHttpRequest({
            method: "GET",
            url: "/document/download",
            params: {
              fileKey: file.fileKey,
              documentId: file.documentId,
            },
          });
          linkFiles.push({ link, fileName: file.name });
        }
      }

      const errorMessages = [];

      await Promise.all(
        linkFiles.map(async ({ link, fileName, ...e }) => {
          try {
            const response = await fetch(link);
            console.log("🚀 ~ linkFiles.map ~ response:", response)

            if (!response.ok) {
              throw new Error(
                `HTTP Error: ${response.status} - ${response.statusText}`
              );
            }

            const blob = await response.blob();

            const fileType = blob.type.split("/")?.[1];

            zip.file(`${fileName}.${fileType}`, blob);
          } catch (error) {
            errorMessages.push(`Error downloading ${fileName}: ${error.message}`);
          }
        })
      );

      if (errorMessages.length > 0) {
        console.error(errorMessages);
        Swal.fire("Desculpe!", "Erro ao baixar arquivos!", "error");
      } else {
        const content = await zip.generateAsync({ type: "blob" });

        const blobUrl = URL.createObjectURL(content);
        const link = document.createElement("a");
        link.href = blobUrl;
        link.download = `Documento_${new Date().toLocaleDateString(
          "pt-br"
        )}.zip`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(blobUrl);

        Swal.close();
        Swal.fire("Sucesso!", "Arquivos baixados com sucesso.", "success");
      }
    } catch (error) {
      console.error(error);
      Swal.fire("Desculpe!", "Erro ao baixar arquivos!", "error");
    }
  };

  return (
    <>
      <Loading isLoading={loading} />
      <Modal
        open={props.open}
        onClose={handleCloseModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        disableEnforceFocus // não fecha quando perde o foco
      >
        <Box
          className={styles.modalBackdrop}
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            zIndex: 999,
          }}
        >
          <Box
            className={styles.modalCard}
            sx={{
              width: "700px",
              height: "fit-content",
              overflowY: "scroll",
              maxHeight: "80%",
              backgroundColor: globalColors.colorWhite,
              borderRadius: "8px",
              boxShadow: 24,
              p: 4,
            }}
          >
            <Typography
              className={styles.modalTitle}
              id="modal-modal-title"
              style={{
                textAlign: "center",
                color: globalColors.primaryColor1,
                marginTop: "20px",
              }}
              variant="h1"
              fontSize="24px"
              fontWeight="bold"
            >
              Enviar Documento
            </Typography>
            <Typography
              className={styles.modalDescription}
              id="modal-modal-description"
              style={{
                color: globalColors.textColor2,
                fontSize: "16px",
                textAlign: "center",
                marginTop: "24px",
              }}
            >
              <span>
                Selecione ou arraste os documentos solicitados pelo escritório.
              </span>
            </Typography>

            {seeDownloadAllButton && (
              <div
                className={styles.downloadAll}
                onClick={() => handleDownloadAll()}
              >
                <button>BAIXAR TODOS</button>
              </div>
            )}

            {files.map(({ file }, index) => (
              <Box
                className={styles.uploadRow}
                key={file?.id || file?.fileKey || `${file?.name || "upload"}-${index}`}
              >
                <label
                  className={`${styles.dropzone} ${file ? styles.dropzoneSelected : ""}`}
                  htmlFor={`document-upload-${index}`}
                  onDragOver={(event) => event.preventDefault()}
                  onDrop={(event) => handleDropFiles(event, index)}
                >
                  <span className={styles.uploadIcon} aria-hidden="true">
                    <FiUpload />
                  </span>
                  <strong>
                    {file?.name
                      ? file.name
                      : "Arraste arquivos aqui ou clique para selecionar"}
                  </strong>
                  <small>
                    {file?.name
                      ? "Clique para substituir ou arraste outro arquivo"
                      : "PDF, JPG, PNG — Máximo 125 MB por arquivo"}
                  </small>
                  <input
                    id={`document-upload-${index}`}
                    type="file"
                    multiple
                    onChange={(event) => handleChangeFiles(event, index)}
                    hidden
                  />
                </label>
                {!file?.id && (
                  <div className={styles.button}>
                    <SvgIcon
                      onClick={() => {
                        handleDelteRow(index);
                      }}
                      style={{
                        width: "28px",
                        height: "28px",
                        color: globalColors.backgroundColor2,
                        fill: "transparent",
                        cursor: "pointer",
                      }}
                      component={trashIcon}
                    />
                  </div>
                )}

                {file && !file.type && (
                  <div className={styles.button}>
                    <SvgIcon
                      component={downloadIcon}
                      onClick={() =>
                        handleDownloadRow(file.fileKey, file?.documentId)
                      }
                      style={{
                        width: "28px",
                        height: "28px",
                        color: globalColors.backgroundColor2,
                        fill: "transparent",
                        cursor: "pointer",
                      }}
                      title={"Baixar documento anexado"}
                    />
                  </div>
                )}
              </Box>
            ))}

            <div className={styles.addButton} onClick={handleAddRow}>
              <SvgIcon
                component={iconPlus}
                alt="Cadastrar novo"
                fill={globalColors.primaryColor1}
                viewBox="0 0 16 15"
                style={{
                  width: "30px",
                  height: "32px",
                  fill: globalColors.primaryColor1,
                  color: globalColors.primaryColor1,
                }}
              />
            </div>

            <Box
              className={styles.modalActions}
              sx={{
                display: "flex",
                justifyContent: "center",
                width: "100%",
                marginTop: "24px",
                boxShadow: "none",
              }}
            >
              <Button
                className={styles.cancelButton}
                variant="secondary"
                color={globalColors.primaryColor2}
                type="button"
                onClick={() => {
                  props.handleOpen(false);
                  setFiles([{ file: "" }]);
                }}
                style={{
                  boxShadow: "none",
                  display: "flex",
                  alignItems: "center",
                  color: globalColors.primaryColor1,
                }}
              >
                <IconCircleLeft />
                <Typography
                  fontWeight="bold"
                  style={{
                    marginLeft: "5px",
                    textDecoration: "underline",
                    color: globalColors.primaryColor1,
                  }}
                >
                  {" "}
                  Cancelar
                </Typography>
              </Button>
              <Button
                className={styles.saveButton}
                variant="primary"
                type="submit"
                style={{
                  backgroundColor: globalColors.primaryColor1,
                  boxShadow: "none",
                  alignItems: "center",
                  color: globalColors.textColor1,
                  width: "150px",
                  height: "48px",
                  borderRadius: "8px",
                }}
                onClick={() => {
                  submitUpload();
                }}
                title={"anexar"}
              >
                <span className="text-light">
                  {loading ? "...Carregando" : "Salvar"} <IconCircleRight />
                </span>
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>
    </>
  );
};

export default UploadModal;
